@if(!isDataLoading){
<div class="linked__positions--card mr-6 mb-3">
  <span class="app__template--linked--header"> Linked Assets, Liabilities, and Entities </span>
  <div class="flex flex-col gap-4 mt-3">
    @for (linkedPosition of linkedPositionsList; track linkedPosition.key) {
    <common-ownership-table-view
      [canCreateNew]="true"
      [showSelection]="true"
      [showActions]="true"
      [rowActions]="['delete']"
      [title]="linkedPosition.title"
      [records]="linkedPosition.items"
      [categoryKey]="linkedPosition.key"
      [hasAutoAddSetting]="hasAutoAddSetting"
      [isBuySellTemplate]="isBuySellTemplate"
      [linkedItems]="[]"
      [tableConfig]="linkedPosition.tableConfig"
      [allUserInstanceForms]="linkedPosition.allUserInstanceForms"
      [searchBoxPlaceHolder]="linkedPosition.searchBoxPlaceHolder"
      [isRemoveEditSaveSharing]="isRemoveEditSaveSharing"
      (onRowActionClick)="onRowActionClick($event)"
      [userSettingPreference]="linkedPosition.autoAddIsEnabled"
      (onRemoveSelected)="deleteVaultUserFormLinkedPositions($event)"
      (onToggleChangeEventEmitter)="onToggleChangeEventEmitterHandler($event, linkedPosition.key)"
      (onCellDataClickEventEmitter)="onCellDataClickEventEmitterHandler($event)"
      (onItemSelectionChangeEventEmitter)="onItemSelectionChangeEventEmitterHandler($event)"
      (onCheckboxSelectionChange)="onLinkedPositionSelectionChange($event)"
    >
    </common-ownership-table-view>
    }
  </div>
</div>
}
